// extracted by mini-css-extract-plugin
export default {"innerWrapper":"ku-z","tooltipWrapper":"lu-z","icon":"mu-z","tooltip":"nu-z","content":"ou-z"};